import { Button, Text } from '@mantine/core';
import { SessionEndReason } from '@dealstack/shared/lib/common/session/sessionContract';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	reason: SessionEndReason;
	onContinue: () => void;
}

const EXPLANATION: Record<SessionEndReason, string> = {
	[SessionEndReason.IDLE]:
		'You were signed out because there was no activity for a while. Sign in again to pick up where you left off.',
	[SessionEndReason.ABSOLUTE]:
		'Your session reached its time limit and was closed. Sign in again to pick up where you left off.',
	[SessionEndReason.ENDED]: 'Your session ended. Sign in again to pick up where you left off.',
	[SessionEndReason.SIGNED_OUT]: 'You have been signed out.',
};

export const SessionEndedNotice = ({ reason, onContinue }: Props) => (
	<div className="min-h-screen flex flex-col items-center justify-center">
		<Text c="dark.6" fw={700} style={{ fontSize: '40px', lineHeight: '52px' }}>
			Your session has ended
		</Text>
		<Text size="B4Medium" c="dark.0" style={{ maxWidth: '560px', marginTop: '16px' }}>
			{EXPLANATION[reason]}
		</Text>
		<Button
			type="button"
			variant="primary"
			size="lg"
			style={{ marginTop: '32px', padding: '8px 16px', height: '48px' }}
			data-testid={TEST_ELEMENT_IDS.SESSION_ENDED_CONTINUE_BUTTON}
			onClick={onContinue}
		>
			Sign in again
		</Button>
	</div>
);
